module App.Classes {
    export class ReplacementVehicle implements Interfaces.IReplacementVehicle {
        id: string;
        name: string;
        price: number;
        discountPrice: number | null;
        code: string;
        isAvailable: boolean;
        showPickupForm: boolean;
    }
}